import { render, staticRenderFns } from "./TwoStepCaptcha.vue?vue&type=template&id=4a462ef6&scoped=true&"
import script from "./TwoStepCaptcha.vue?vue&type=script&lang=js&"
export * from "./TwoStepCaptcha.vue?vue&type=script&lang=js&"
import style0 from "./TwoStepCaptcha.vue?vue&type=style&index=0&id=4a462ef6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a462ef6",
  null
  
)

export default component.exports